(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nm-free-ring-sizer"] && !Shopify.designMode) return;
  try {
    
function initNicoleMansonSizing(scope) {
  scope.querySelectorAll('[data-nm-free-sizing]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const select = root.querySelector('[data-mfs-request]');
    const address = root.querySelector('[data-mfs-address]');
    const size = root.querySelector('[data-mfs-size]');
    function sync() {
      const kit = select.selectedOptions[0].dataset.kind === 'kit';
      address.hidden = !kit;
      size.hidden = kit;
      address.querySelectorAll('input').forEach(el => { el.disabled = !kit; el.required = kit && el.hasAttribute('data-kit-required'); });
      size.querySelectorAll('input,select').forEach(el => { el.disabled = kit; el.required = !kit; });
    }
    select.addEventListener('change', sync);
    root.querySelectorAll('[data-mfs-choice]').forEach(link => link.addEventListener('click', () => {
      select.selectedIndex = link.dataset.mfsChoice === 'confirm' ? 1 : 0;
      sync();
    }));
    const params = new URLSearchParams(location.search);
    const product = root.querySelector('[data-mfs-product]');
    if (params.get('product') && !product.value) product.value = params.get('product').slice(0,300);
    sync();
    const success = root.querySelector('.mfs-success');
    if (success) success.focus();
  });
}
initNicoleMansonSizing(document);
document.addEventListener('shopify:section:load', event => initNicoleMansonSizing(event.target));

  } catch(e) { console.error(e); }
})();
})();
